import React, { useState, useEffect, useRef } from 'react';
import './InfoUser.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faChevronDown, faIdBadge } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from 'react-router-dom';
import Swal from 'sweetalert2';
import baseURL from '../../url';

export default function InfoUser() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        fetch(`${baseURL}/userLogued.php`)
            .then(res => res.json())
            .then(data => {
                setUsuario(data || {});
                setLoading(false);
            })
            .catch(() => setLoading(false));

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = () => {
        setDropdownOpen(false);
        Swal.fire({
            title: '¿Cerrar sesión?',
            text: '¿Estás seguro de que deseas salir del sistema?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, cerrar sesión',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await fetch(`${baseURL}/logout.php`);
                    localStorage.removeItem('usuario');
                    Swal.fire({
                        title: 'Sesión finalizada',
                        text: 'Has salido correctamente del sistema.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/dashboard';
                    }, 1200);
                } catch (e) {
                    window.location.reload();
                }
            }
        });
    };

    if (loading) {
        return <div className="userLoadingBadge">...</div>;
    }

    const inicial = usuario.nombre ? usuario.nombre.charAt(0).toUpperCase() : 'U';

    return (
        <div className="userInfoWrapper" ref={dropdownRef}>
            <button
                type="button"
                className="userTriggerBtn"
                onClick={() => setDropdownOpen(prev => !prev)}
                title="Opciones de cuenta"
            >
                <div className="userAvatarCircle">
                    {inicial}
                </div>
                <div className="userNameAndRole">
                    <span className="userNameText">{usuario.nombre || 'Usuario'}</span>
                    <span className="userRoleBadge">{usuario.rol || 'admin'}</span>
                </div>
                <FontAwesomeIcon icon={faChevronDown} className={`chevronIcon ${dropdownOpen ? 'rotated' : ''}`} />
            </button>

            {dropdownOpen && (
                <div className="userDropdownMenu">
                    <div className="userDropdownHeader">
                        <div className="userDropdownAvatarBig">{inicial}</div>
                        <div className="userDropdownMeta">
                            <strong>{usuario.nombre}</strong>
                            <span>{usuario.email || ''}</span>
                            <span className="rolePill">Rol: {usuario.rol}</span>
                        </div>
                    </div>

                    <div className="userDropdownDivider"></div>

                    <Anchor
                        to="/dashboard/perfil"
                        className="userDropdownItem"
                        onClick={() => setDropdownOpen(false)}
                    >
                        <FontAwesomeIcon icon={faIdBadge} /> Ver perfil
                    </Anchor>

                    <button
                        type="button"
                        className="userDropdownItem logoutItem"
                        onClick={handleLogout}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión
                    </button>
                </div>
            )}
        </div>
    );
}
